/* State Interface Imports */

import StateInterface from "../state-interface";
import { beegru_points_transaction } from "./beegru-points-transaction";
import { business_profile } from "./business-profile";
import { cash_transaction } from "./cash-transaction";
import { subscription_plans } from "./subscription-plans";
import { user } from "./user";

/* Account Page Page Default State Data */

export const account_settings_page: StateInterface["account_settings_page"] = {
	user_data: user,
	user_cash_transactions: [cash_transaction],
	user_beegru_points_transactions: [beegru_points_transaction],
	subscription_plans: [subscription_plans],
	subscriptions: [
		{
			_id: "62e4dcc7893a5fc8c8b287c4",
			plan_slug: "landowner-premium",
			subscribed_user_id: "62e4dcc7893a5fc8c8b287c4",
			subscribed_entity: "Siddhant Vinchurkar",
			subscribed_entity_id: "62e4dcc7893a5fc8c8b287c4",
			start_date: "2020-01-01T00:00:00.000Z",
			end_date: "2020-01-01T00:00:00.000Z",
			trigger_end_date: "2020-01-01T00:00:00.000Z",
			active: false,
			cancelled: false,
			cancelled_at: "2020-01-01T00:00:00.000Z",
			created_at: "2020-01-01T00:00:00.000Z",
			updated_at: "2020-01-01T00:00:00.000Z",
		},
	],
	business_profiles: [business_profile],
	file_counts: {
		videos: 0,
		images: 0,
		documents: 0,
		total: 0,
	},
	file_sizes: {
		videos: 0,
		images: 0,
		documents: 0,
		total: 0,
	},
	file_size_percentages: {
		videos: 0,
		images: 0,
		documents: 0,
		total: 0,
	},
	allocated_storage: 0,
	rewards_transaction: [beegru_points_transaction],
	one_time_rewards: [],
	recurring_rewards: [],
	current_screen: "home",
};
